import React from 'react';

import PropTypes from 'prop-types';

import useForm from 'components/hooks/useForm';

import FilledButton from 'components/application/buttons/FilledButton';
import TextButton from 'components/application/buttons/TextButton';
import ErrorMessage from 'components/application/ErrorMessage';
import ModalBox from 'components/application/ModalBox';
import TextField from 'components/application/TextField';

import { defaultFolder } from 'components/projectsDashboard/helpers';

export default function CreateFolderModal({
  isCreateDisabled = false,
  onClose,
  onCreateSubmit,
  onInputFocus,
  requestError,
}) {
  const [currentFolder, , handleCurrentFolderInputChange] =
    useForm(defaultFolder);

  return (
    <ModalBox
      customFooter={
        <div className='modalbox__footer-actions modalbox__footer-actions--right'>
          <TextButton
            className='tw-mr-3'
            color='blue'
            onClick={onClose}
            size='md'
          >
            Cancel
          </TextButton>
          <FilledButton
            color='mint'
            disabled={currentFolder.name.length === 0 || isCreateDisabled}
            onClick={() => onCreateSubmit({ folderParams: currentFolder })}
          >
            Create folder
          </FilledButton>
        </div>
      }
      isOpen={true}
      mode='letterbox'
      onClose={onClose}
    >
      <>
        <div className='modalbox-header tw-border-grey-100'>
          <h2 className='modalbox-header__title truncated-text-container tw-text-l tw-font-semibold tw-text-grey-900'>
            New folder
          </h2>
        </div>
        <div className='modalbox-body'>
          <ErrorMessage
            isFallback={false}
            modifiers='tw-mb-3'
            validationErrors={requestError.validationErrors}
          />
          <TextField
            autoFocus={true}
            fieldError={requestError.validationErrors.name}
            inputClassName='tw-px-3 tw-py-[9px]'
            isRequired={true}
            label='Folder name'
            name='name'
            onChange={handleCurrentFolderInputChange}
            placeholder='Enter unique name for folder'
            removeErrorStyling={onInputFocus}
            value={currentFolder.name}
          />
        </div>
      </>
    </ModalBox>
  );
}

CreateFolderModal.propTypes = {
  isCreateDisabled: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onCreateSubmit: PropTypes.func.isRequired,
  onInputFocus: PropTypes.func.isRequired,
  requestError: PropTypes.shape({
    isFallback: PropTypes.bool.isRequired,
    validationErrors: PropTypes.object.isRequired,
  }),
};
